// 3rd party
import React from "react";
import { FormattedMessage } from "react-intl";
import { Grid } from "@material-ui/core";

// components
import { Card } from "../common/card/card";
import { Header } from "../common/title/header";
import { useWorkOrderStyles, Caption, Value, CardTitle } from "./workOrderDetails";

const WorkOrderCreationInformation = ({ relatedIdInformation = {} }) => {
    const ticketCreationInfo = relatedIdInformation?.technicianDetails;
    const classes = useWorkOrderStyles();
    if (!ticketCreationInfo) {
        return null;
    }

    return (
        <>
            {ticketCreationInfo && (
                <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.noBottomPadding}>
                        <Header>
                            <FormattedMessage
                                id="admin.work-order-details.wo-info.ticket-creation-title"
                                defaultMessage="Ticket creation information"
                                description="Admin Ticket creation information title"
                            />
                        </Header>
                    </Grid>
                    <Grid item xs={12}>
                        <Card>
                            <CardTitle>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.ticket-details-title"
                                    defaultMessage="WO creation details"
                                    description="Admin work order creation details title"
                                />
                            </CardTitle>
                            <Grid container className={classes.row}>
                                <Grid item xs={3}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.ticket-created-by-caption"
                                            defaultMessage="Created by"
                                            description="Admin work order Created by caption"
                                        />
                                    </Caption>
                                    <Value>{ticketCreationInfo.firstName + " " + ticketCreationInfo.lastName}</Value>
                                </Grid>
                                <Grid item xs={2}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.ticket-pein-caption"
                                            defaultMessage="PEIN"
                                            description="Admin work order creation PEIN caption"
                                        />
                                    </Caption>
                                    <Value>{ticketCreationInfo.employeeID}</Value>
                                </Grid>
                                <Grid item xs={2}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.ticket-creation-company-caption"
                                            defaultMessage="Company"
                                            description="Admin work order creation company caption"
                                        />
                                    </Caption>
                                    <Value>{ticketCreationInfo.company}</Value>
                                </Grid>
                                <Grid item xs={2}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.ticket-mobile-number-caption"
                                            defaultMessage="Mobile number"
                                            description="Admin work order creation mobile number caption"
                                        />
                                    </Caption>
                                    <Value>{ticketCreationInfo.mobileNumber}</Value>
                                </Grid>
                                <Grid item xs={3}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.ticket-email-caption"
                                            defaultMessage="Email"
                                            description="Admin work order creation email caption"
                                        />
                                    </Caption>
                                    <Value>{ticketCreationInfo.email}</Value>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default WorkOrderCreationInformation;
